import { responsiveModalClosed } from '../../model';

export const closeResponsiveModal = (modalId?: string) => {
    responsiveModalClosed(modalId);
};
